import _toConsumableArray from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Horizon\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

function log(method, level, input) {
  var _console;

  var msg = [level].concat([].slice.call(input));

  (_console = console)[method].apply(_console, _toConsumableArray(msg)); // eslint-disable-line no-console

}

export var None = 0;
export var Error = 1;
export var Warn = 2;
export var Info = 3;
export var Debug = 4;
export default function (_, method) {
  var _level = _ || None;

  return {
    level: function level(_) {
      if (arguments.length) {
        _level = +_;
        return this;
      } else {
        return _level;
      }
    },
    error: function error() {
      if (_level >= Error) log(method || 'error', 'ERROR', arguments);
      return this;
    },
    warn: function warn() {
      if (_level >= Warn) log(method || 'warn', 'WARN', arguments);
      return this;
    },
    info: function info() {
      if (_level >= Info) log(method || 'log', 'INFO', arguments);
      return this;
    },
    debug: function debug() {
      if (_level >= Debug) log(method || 'log', 'DEBUG', arguments);
      return this;
    }
  };
}